<div class="rail-content">

  <!-- 1 · Product-type pill tabs (4-up, MULTI-SELECT) -->
  <div class="rail-section">
    <div class="rail-pill-tabs">
      @for (type of types; track type.id) {
        <button
          type="button"
          class="rail-pill-tab"
          [class.active]="activeTypes().has(type.id)"
          (click)="onTypeClick(type.id)"
        >
          {{ type.label }}
        </button>
      }
    </div>
  </div>

  <!-- Scope (P2) — All / My Shelf at rail-top (parity with rates). No Changes
       row: rate-direction (▲▼◆) doesn't apply to product search. -->
  @if (showShelfScope()) {
    <div class="rail-scope-grp">
      <div class="scope-label">Scope</div>
      <div class="scope-row">
        <span class="scope-row-label">Products</span>
        <div class="shelf-switch"
             [class.shelf-switch-disabled]="shelfState() === 'disabled'"
             [attr.title]="shelfState() === 'disabled' ? 'Select a user via Admin to enable' : 'Toggle between all products and your shelf'">
          <span class="shelf-sw-opt"
                [class.shelf-sw-active]="shelfState() === 'off'"
                (click)="shelfState() === 'on' && onShelfClick()">All</span>
          <span class="shelf-sw-opt"
                [class.shelf-sw-active]="shelfState() === 'on'"
                (click)="shelfState() === 'off' && onShelfClick()">My Shelf</span>
        </div>
      </div>
    </div>
  }

  <!-- Criteria (case editor) — Basic Search REMOVED 2026-06-15. The exposed
       knobs (State/Term/Rating) already live in the Advanced-filter groups, so
       the products rail default is just Filters + Saved Views. Renders ONLY
       when casesEnabled is flipped on (Cases resurrection). -->
  @if (showCriteria() && sessionCtx.casesEnabled()) {
  <div class="rail-criteria" [class.is-open]="criteriaOpen()">
    <button type="button" class="crit-hdr" (click)="toggleCriteria()">
      <svg class="crit-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      <span class="ch-dot" aria-hidden="true"></span>
      <span class="ch-title">{{ sessionCtx.casesEnabled() ? 'Criteria' : 'Basic Search' }}</span>
      @if (sessionCtx.casesEnabled()) {
        @if (caseLoaded()) {
          <span class="ch-who">· {{ caseName() }}</span>
          @if (caseModified()) { <span class="ch-badge">exploring</span> }
        } @else {
          <span class="ch-who ch-none">· none</span>
        }
      }
    </button>
    @if (criteriaOpen()) {
      <div class="crit-body">
        @if (sessionCtx.casesEnabled()) {
          <div class="crit-knob crit-case-pick">
            <label>Case</label>
            <select [ngModel]="activeCaseId()" (ngModelChange)="onCasePick($event)" title="Load or switch the active case">
              <option [ngValue]="null">— No case —</option>
              @if (boundCases().length) { <optgroup label="Cases">@for (c of boundCases(); track c.id) { <option [ngValue]="c.id">{{ c.name }}</option> }</optgroup> }
              @if (personaCases().length) { <optgroup label="Personas">@for (p of personaCases(); track p.id) { <option [ngValue]="p.id">{{ p.name }}</option> }</optgroup> }
            </select>
            <app-case-picker-flyout [cases]="caseList()" [activeId]="activeCaseId()" (pick)="onCasePick($event)"></app-case-picker-flyout>
          </div>
          @if (caseLoaded()) {
            <button type="button" class="crit-edit-case" (click)="editCase()">Edit full case →</button>
          }
        }
        <p class="crit-sub">
          @if (sessionCtx.casesEnabled()) {
            @if (caseAllMode()) { Showing all products — the ones that fit this client are marked ✓. }
            @else if (caseLoaded()) { This client's criteria — products filter live by State, Term &amp; Rating. }
            @else { Set criteria to filter products — then save them as a persona. }
          } @else {
            A few common filters — they filter products by State, Term &amp; Rating. Save the result as a view.
          }
        </p>
        <div class="crit-grid">
          <div class="crit-cell">
            <label>State</label>
            <select [(ngModel)]="kState" [disabled]="caseAllMode()"><option value="">— any —</option>@for (s of statesList; track s) { <option [value]="s">{{ s }}</option> }</select>
          </div>
          <!-- Age + Premium are case-context only (don't filter products) —
               shown solely when Cases is active; hidden in Basic Search. -->
          @if (sessionCtx.casesEnabled()) {
            <div class="crit-cell">
              <label>Age <span class="crit-ctx-tag" title="Saved to the case; doesn't filter products">Rates</span></label>
              <input type="number" [ngModel]="kAge" (ngModelChange)="kAge = $event" [disabled]="caseAllMode()" placeholder="—" />
            </div>
            <div class="crit-cell full">
              <label>Premium <span class="crit-ctx-tag" title="Saved to the case; doesn't filter products">Rates</span></label>
              <span class="crit-money"><span class="crit-pre">$</span><input type="number" [ngModel]="kPremium" (ngModelChange)="kPremium = $event" [disabled]="caseAllMode()" placeholder="—" /></span>
            </div>
          }
          <div class="crit-cell full">
            <label>Term (yr)</label>
            <span class="crit-range">
              <input type="number" [ngModel]="kTermMin" (ngModelChange)="kTermMin = $event" [disabled]="caseAllMode()" placeholder="Min" />
              <span class="crit-dash">–</span>
              <input type="number" [ngModel]="kTermMax" (ngModelChange)="kTermMax = $event" [disabled]="caseAllMode()" placeholder="Max" />
            </span>
          </div>
          <div class="crit-cell">
            <label>Rating ≥</label>
            <select [(ngModel)]="kRating" [disabled]="caseAllMode()"><option value="">Any</option><option value="A-">A-</option><option value="A">A</option><option value="A+">A+</option><option value="A++">A++</option></select>
          </div>
        </div>

        @if (sessionCtx.casesEnabled() && caseLoaded()) {
          <div class="crit-mode-row">
            <span class="crit-mode-seg" role="group" aria-label="Case lens mode">
              <button type="button" [class.on]="!caseAllMode()" (click)="setCaseFit()" title="Narrow the grid to products that fit this client">Fit only</button>
              <button type="button" [class.on]="caseAllMode()" (click)="setCaseAll()" title="Show every product; mark the ones that fit with ✓">Show all</button>
            </span>
          </div>
        }

        <div class="crit-foot">
          <span class="crit-count">
            @if (sessionCtx.casesEnabled() && hasAnyCriteria()) { <b>{{ fitCount() }}</b> of {{ totalCount() }} fit }
            @else { {{ totalCount() }} products }
          </span>
          <span class="crit-actions">
            @if (sessionCtx.casesEnabled()) {
              @if (caseLoaded()) {
                @if (!caseAllMode()) {
                  <button type="button" class="crit-btn ghost" (click)="resetToCase()" title="Revert to the saved values">↺ Reset</button>
                  @if (isPersona()) {
                    <button type="button" class="crit-btn ghost" (click)="promoteToCase()" title="Attach a client — turn this persona into a real case">Promote →</button>
                    <button type="button" class="crit-btn amber" (click)="saveToCase()" [disabled]="!caseModified()">Save persona</button>
                  } @else {
                    <button type="button" class="crit-btn amber" (click)="saveToCase()" [disabled]="!caseModified()">Save to case</button>
                  }
                }
              } @else {
                <button type="button" class="crit-btn ghost" (click)="clearCriteria()" [disabled]="!hasAnyCriteria()">↺ Clear</button>
                <button type="button" class="crit-btn amber" (click)="saveAsPersona()" [disabled]="!hasAnyCriteria()">Save as persona</button>
              }
            } @else {
              <!-- Basic Search (cases parked): clear the knobs. -->
              <button type="button" class="crit-btn ghost" (click)="clearCriteria()" [disabled]="!hasAnyCriteria()">↺ Clear</button>
            }
          </span>
        </div>
      </div>
    }
  </div>
  }

  <!-- 2026-06-04 search-consolidation: rail-top search input removed.
       Text search now lives in the page-header (products.component.html)
       and drives both the grid quick-filter and the carrier picker's
       filter via [externalSearchQuery]. -->

  <!-- Status — surfaced as its own top-level rail section (2026-07-13) so it's
       visible without expanding Filters → Company & Product. -->
  <div class="rail-status-grp">
    <label class="rail-field-label">Status</label>
    <div class="rail-status-toggle">
      <button type="button" [class.on]="statusValue() === 'all'" (click)="onStatusClick('all')">All</button>
      <button type="button" [class.on]="statusValue() === 'open'" (click)="onStatusClick('open')">Open</button>
      <button type="button" [class.on]="statusValue() === 'closed'" (click)="onStatusClick('closed')">Closed</button>
    </div>
  </div>

  <!-- Advanced filters — every filter by hand; the Criteria knobs write into
       these. Collapsible header mirrors the rates rail "Advanced filters"
       section. Applied chips (Phase 4.3) sit at the top of the body as the
       applied-state summary; the inline filter groups (Phase 12) follow. -->
  <div class="rail-coll" [class.is-open]="advancedOpen()">
    <button type="button" class="section-hdr" (click)="toggleAdvanced()">
      <svg class="sec-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      <span>Filters</span>
    </button>
    @if (advancedOpen()) {
    <div class="section-body">

      <!-- Applied-state lives in the page-header footprints (products.component.html
           → .ph-footprints), matching the rates rail which removed its in-rail
           applied-chip stack on 2026-06-01. Single surface, no double-surfacing. -->

      <!-- Inline filter groups (Phase 12). Group headers are the discovery
           surface; the carrier picker is a rail-field sub-item alongside
           A.M. Best, Premium Type, Share Class, and Status.
           Prototype (2026-06-11): with bn.manifestRail set, the generic
           manifest-driven <app-filter-rail-groups> renders these instead
           (see the @else below). Default OFF → this hand-written block. -->
      @if (!manifestRail()) {
      <div class="rail-groups">
        <app-product-rail-group name="Company &amp; Product"
        [badge]="carrierLauncherSummary().label" [activeCount]="carrierActive()"
        [forceClosed]="openGroupKey() !== null && openGroupKey() !== 'carrier'"
        (expandRequest)="onGroupExpandRequest('carrier')"
        (collapseEvent)="onCarrierGroupCollapse()">
      <!-- Companies & Products sub-item — wraps the in-rail
           CompanyProductPicker (companies-only mode). Products live in a
           CDK Overlay fly-out anchored to the clicked carrier row. -->
      <div class="carrier-sub" [class.is-open]="carrierSubOpen()">
        <button type="button" class="rail-field-head carrier-sub-head"
                [attr.aria-expanded]="carrierSubOpen()"
                (click)="toggleCarrierSub()">
          <span class="rf-name">Carriers</span>
          @if (carrierLauncherSummary().count === null) {
            <span class="rf-allnone">All</span>
          } @else {
            <span class="rf-summary">{{ carrierLauncherSummary().label }}</span>
          }
        </button>
        @if (carrierSubOpen()) {
          <div class="carrier-picker-wrap">
            <app-company-product-picker
              mode="companies-only"
              [dataInput]="pickerData()"
              [initialSelection]="pickerInitialSelection()"
              [externalSearchQuery]="pageSearchText()"
              (selectionChange)="onPickerSelectionChange($event)"
              (rowClick)="onCarrierRowClick($event)" />
          </div>
        }
      </div>
      <app-product-checklist-picker field="selectedPremiumTypes" label="Premium Type" mode="multi"
          [options]="options('premiumType')" [highlightQuery]="''" (closeRequest)="onPickerCloseRequest($event)" />
      <app-product-checklist-picker field="selectedAmBest" label="A.M. Best" mode="multi"
          [options]="options('amBest')" [highlightQuery]="''" (closeRequest)="onPickerCloseRequest($event)" />
      <app-product-checklist-picker field="selectedShareClasses" label="Share Class" mode="multi"
          [options]="options('shareClass')" [highlightQuery]="''" (closeRequest)="onPickerCloseRequest($event)" />
    </app-product-rail-group>

    <app-product-rail-group name="Surrenders &amp; Premium"
        [badge]="termBadge()" [activeCount]="termActive()"
        [forceClosed]="openGroupKey() !== null && openGroupKey() !== 'term'"
        (expandRequest)="onGroupExpandRequest('term')">
      <app-product-checklist-picker field="selectedSurrYears" label="Surrender Years" mode="multi"
          [options]="options('surrYears')" [labelMap]="surrYearsLabels" [highlightQuery]="''"
          (closeRequest)="onPickerCloseRequest($event)" />
      <app-product-premium-input field="selectedPremium" label="Premium" />
    </app-product-rail-group>

    <app-product-rail-group name="Riders &amp; Features"
        [badge]="featuresBadge()" [activeCount]="featuresActive()"
        [forceClosed]="openGroupKey() !== null && openGroupKey() !== 'features'"
        (expandRequest)="onGroupExpandRequest('features')">
      <!-- headless: the checklist IS the group body. This group holds exactly
           one dimension, so a "Riders" row here was a second accordion opening
           the one thing "Riders & Features" already promised — and its summary
           duplicated featuresBadge() a line above it. Same change as State
           Availability. `label` stays for the dim's identity in the markup even
           though no head row renders it. -->
      <app-product-checklist-picker field="selectedRiders" label="Riders" mode="multi"
          [headless]="true"
          [options]="options('riders')" [highlightQuery]="''" (closeRequest)="onPickerCloseRequest($event)" />
    </app-product-rail-group>

    <app-product-rail-group name="State Availability"
        [badge]="geographyBadge()" [activeCount]="geographyActive()"
        [forceClosed]="openGroupKey() !== null && openGroupKey() !== 'geography'"
        (expandRequest)="onGroupExpandRequest('geography')">
      <!-- The grid IS the group body, matching /rates. This group holds exactly
           one dimension, so the picker row that used to sit here was a second
           accordion whose only job was to open the one thing the group already
           promised — two clicks to reach the states, under a "State" label
           directly below "State Availability". The group header still carries
           the summary via geographyBadge(), so nothing moved out of view.

           No [selected] option list: the grid always shows all 50 states rather
           than only those present in the current data, so it can't shrink under
           the reader as other filters narrow. -->
      <div class="states-body">
        <app-state-availability-grid
          [selected]="selectedStates()"
          (stateToggle)="toggleState($event)" />
      </div>
    </app-product-rail-group>
      </div>
      } @else {
        <!-- Architectural prototype — one generic component renders all groups
             from PRODUCTS_FILTER_MANIFEST; carrier + Status are projected via
             the slot templates below. -->
        <app-filter-rail-groups
          [manifest]="productsManifest"
          [optionsFor]="optionsForFn"
          [slots]="railSlots()" />
      }
    </div>
    }
  </div>

  <!-- Prototype slot templates (2026-06-11) — the carrier fly-out + Status
       toggle that FilterRailGroups projects into the Company & Product group.
       Duplicated from the legacy block above so the default (flag-off) rail
       stays byte-identical; removed when the prototype graduates. -->
  <ng-template #carrierTpl>
    <div class="carrier-sub" [class.is-open]="carrierSubOpen()">
      <button type="button" class="rail-field-head carrier-sub-head"
              [attr.aria-expanded]="carrierSubOpen()"
              (click)="toggleCarrierSub()">
        <span class="rf-name">Carriers</span>
        @if (carrierLauncherSummary().count === null) {
          <span class="rf-allnone">All</span>
        } @else {
          <span class="rf-summary">{{ carrierLauncherSummary().label }}</span>
        }
      </button>
      @if (carrierSubOpen()) {
        <div class="carrier-picker-wrap">
          <app-company-product-picker
            mode="companies-only"
            [dataInput]="pickerData()"
            [initialSelection]="pickerInitialSelection()"
            [externalSearchQuery]="pageSearchText()"
            (selectionChange)="onPickerSelectionChange($event)"
            (rowClick)="onCarrierRowClick($event)" />
        </div>
      }
    </div>
  </ng-template>
  <ng-template #statusTpl>
    <label class="rail-field-label">Status</label>
    <div class="rail-status-toggle">
      <button type="button" [class.on]="statusValue() === 'all'" (click)="onStatusClick('all')">All</button>
      <button type="button" [class.on]="statusValue() === 'open'" (click)="onStatusClick('open')">Open</button>
      <button type="button" [class.on]="statusValue() === 'closed'" (click)="onStatusClick('closed')">Closed</button>
    </div>
  </ng-template>

</div>
